export {};
//# sourceMappingURL=CopilotMessageFooter.types.js.map